<template>
  <div>
    <h3>{{ title }}</h3>
    <div v-for="candidato in lista" :key="`candidato-${candidato.numero}`">
      <ProgressoCandidato
        v-if="destaque"
        :candidato="candidato"
        :perc="((candidato.total_votos / totalVotos) * 100).toFixed(2)"
      />
      <ProgressoGeral
        v-else
        :candidato="candidato"
        :perc="((candidato.total_votos / totalVotos) * 100).toFixed(2)"
      />
    </div>
  </div>
</template>

<script>
import ProgressoCandidato from './ProgressoCandidato'
import ProgressoGeral from './ProgressoGeral'

export default {
  components: { ProgressoCandidato, ProgressoGeral },
  props: {
    title: {
      type: String,
      required: true
    },
    lista: {
      type: Array,
      required: true
    },
    totalVotos: {
      type: Number,
      required: true
    },
    destaque: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EleicaoConselho/ListaCandidatos.vue